import React from 'react';
import { EventsManagement } from '@/components/events/EventsManagement';

export const EventsPage: React.FC = () => {
  return <EventsManagement />;
};
